import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=fb074f0c&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=fb074f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb074f0c",
  null
  
)

export default component.exports